import { User } from "lucide-react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  // ReferenceLine,
  ResponsiveContainer,
} from "recharts";

const data = [
  {
    name: "Page A",
    income: 4000,
    expense: 2400,
    amt: 2400,
  },
  {
    name: "Page B",
    income: 3000,
    expense: 1398,
    amt: 2210,
  },
  {
    name: "Page C",
    income: 2000,
    expense: 9800,
    amt: 2290,
  },
  {
    name: "Page D",
    income: 2780,
    expense: 3908,
    amt: 2000,
  },
  {
    name: "Page E",
    income: 1890,
    expense: 4800,
    amt: 2181,
  },
  {
    name: "Page F",
    income: 2390,
    expense: 3800,
    amt: 2500,
  },
  {
    name: "Page G",
    income: 3490,
    expense: 4300,
    amt: 2100,
  },
];

const ActivityGraph = () => {
  return (
    <div className="overflow-hidden border border-bkg2 bg-content flex-1 shadow-lg h-60 rounded-lg p-3">
      <div>
        <h5 className="flex items-center gap-1.5 font-medium ">
          <User size={18} /> Activity
        </h5>
      </div>
      <ResponsiveContainer width="100%" height="93%">
        <LineChart width={500} height={300} data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" padding={{ left: 30, right: 30 }} />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line
            type="monotone"
            dataKey="expense"
            stroke="#8884d8"
            activeDot={{ r: 8 }}
          />
          <Line type="monotone" dataKey="income" stroke="#82ca9d" />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ActivityGraph;
